import { createBrowserRouter, redirect } from "react-router-dom";

import Landing from "../components/Landing";
import Dashboard from "../components/Dashboard";
import ErrorPage from "../components/ErrorPage";
import Retention from "../components/Retention";
import RetentionV2 from "modules/Retention/components";
import Inbox from "modules/Retention/components/Inbox";
import Roster from "modules/Retention/components/Roster";
import Reports from "modules/Retention/components/Reports";
import EmployeeProfile from "../components/EmployeeProfile";
import Settings from "modules/Retention/components/Settings";
import ProtectedRoute from "../components/Routes/ProtectedRoutes";
import RetentionPersonnel from "../components/RetentionPersonnel";
import Referral from "../modules/Referrals/components/Referral/Referral";
import EmployeeProfileV2 from "modules/Retention/components/EmployeeProfile";
import CaregiverProfile from "../components/CaregiverProfile/CaregiverProfile";
import RecognitionLogin from "../modules/Recognition/components/RecognitionLogin";
import RecognitionOutlet from "../modules/Recognition/components/RecognitionOutlet";
import RetentionDashboard from "../components/RetentionDashboard/RetentionDashboard";
import ReferralOutlet from "../modules/Referrals/components/ReferralOutlet/ReferralOutlet";
import SearchEmployees from "../modules/Retention/components/SearchEmployees/SearchEmployees";
import RecognitionHome from "../modules/Recognition/components/RecognitionHome/RecognitionHome";
import RecognitionSearchEmployee from "../modules/Recognition/components/RecognitionSearchEmployee";
import EscalationFollowUp from "modules/Escalation/components/EscalationFollowUp/EscalationFollowUp";
import RecognitionEmployeeProfile from "../modules/Recognition/components/RecognitionEmployeeProfile";
import RecognitionOTPVerification from "../modules/Recognition/components/RecognitionOTPVerification";
import RecognitionPrivateComponent from "../modules/Recognition/components/RecognitionPrivateComponent";
import ReferralIntermediateRedirector from "../modules/Referrals/components/ReferralIntermediateRedirector/ReferralIntermediateRedirector";

export default createBrowserRouter([
  {
    path: "/",
    element: <Landing />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/caregivers/:id",
    element: (
      <ProtectedRoute>
        <CaregiverProfile />
      </ProtectedRoute>
    ),
  },
  {
    path: "/retention",
    element: (
      <ProtectedRoute>
        <Retention />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        loader: () => redirect("/retention/dashboard"),
      },
      {
        path: "dashboard",
        element: (
          <ProtectedRoute>
            <RetentionDashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "personnel",
        element: (
          <ProtectedRoute>
            <RetentionPersonnel />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "/employees/:id",
    element: (
      <ProtectedRoute>
        <EmployeeProfile />
      </ProtectedRoute>
    ),
  },
  {
    path: "/escalations/:id/follow-up",
    element: <EscalationFollowUp />,
  },
  {
    path: "/recognition",
    element: <RecognitionOutlet />,
    children: [
      {
        index: true,
        loader: () => redirect("/"),
      },
      {
        path: "login",
        element: <RecognitionLogin />,
      },
      {
        path: "otp-verification",
        element: <RecognitionOTPVerification />,
      },
      {
        path: "direct-at",
        element: (
          <ProtectedRoute redirectPath="/recognition/login">
            <RecognitionPrivateComponent>
              <RecognitionHome />
            </RecognitionPrivateComponent>
          </ProtectedRoute>
        ),
      },
      {
        path: "search-employees",
        element: (
          <ProtectedRoute redirectPath="/recognition/login">
            <RecognitionPrivateComponent>
              <RecognitionSearchEmployee />
            </RecognitionPrivateComponent>
          </ProtectedRoute>
        ),
      },
      {
        path: "me",
        element: (
          <ProtectedRoute redirectPath="/recognition/login">
            <RecognitionPrivateComponent>
              <RecognitionEmployeeProfile />
            </RecognitionPrivateComponent>
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "/referral",
    element: <ReferralOutlet />,
    children: [
      {
        index: true,
        loader: () => redirect("/"),
      },
      {
        path: "agape-care-group",
        element: <Referral />,
      },
      {
        path: "royal-home-care",
        element: <Referral />,
      },
      {
        path: "longevity-care",
        element: <Referral />,
      },
      {
        path: "comfort-keepers",
        element: <Referral />,
      },
      {
        path: "st-croix",
        element: <Referral />,
      },
      {
        path: "helping-hands",
        element: <Referral />,
      },
      {
        path: "intermediate-redirector",
        element: <ReferralIntermediateRedirector />,
      },
    ],
  },
  {
    path: "/retention/V2",
    element: (
      <ProtectedRoute>
        <RetentionV2 />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        loader: () => redirect("/retention/V2/inbox"),
      },
      {
        path: "inbox",
        element: (
          <ProtectedRoute>
            <Inbox />
          </ProtectedRoute>
        ),
      },
      {
        path: "employees/:id",
        element: (
          <ProtectedRoute>
            <EmployeeProfileV2 />
          </ProtectedRoute>
        ),
      },
      {
        path: "roster",
        element: (
          <ProtectedRoute>
            <Roster />
          </ProtectedRoute>
        ),
      },
      {
        path: "reports",
        element: (
          <ProtectedRoute>
            <Reports />
          </ProtectedRoute>
        ),
      },
      {
        path: "settings",
        element: (
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        ),
      },
    ],
  },
]);
